// 노쇠지수 AI 브리핑 조회. 서버가 (현재·직전 결과) 쌍마다 한 번 만들어 캐시한다 — 처음 열 때만 수십 초가 걸린다.
//
// ⚠️ 카드가 먼저 뜨고 브리핑은 뒤에 온다. 브리핑이 없거나 실패해도 점수 카드는 그대로다.

import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/config';

export default function useFrailBriefing(appUserId, indexId, enabled = true) {
    const [state, setState] = useState({ status: 'idle', briefing: null, createdAt: null, error: null });
    const [nonce, setNonce] = useState(0);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        if (!appUserId || !indexId || !enabled) { setState({ status: 'idle', briefing: null, createdAt: null, error: null }); return undefined; }
        let cancelled = false;
        setState((s) => ({ ...s, status: 'loading', error: null }));
        (async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_BASE_URL}/api/patients/${appUserId}/frail/briefing`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: refresh ? { refresh: '1' } : {},
                    timeout: 180000
                });
                if (cancelled) return;
                const data = response.data || {};
                setState({ status: data.status || 'ready', briefing: data.briefing || null, createdAt: data.createdAt || null, error: null });
            } catch (error) {
                if (!cancelled) setState({ status: 'failed', briefing: null, createdAt: null, error: error.response?.data?.message || error.message });
            }
        })();
        return () => { cancelled = true; };
    }, [appUserId, indexId, enabled, nonce, refresh]);

    const regenerate = useCallback(() => { setRefresh(true); setNonce((n) => n + 1); }, []);
    return { ...state, regenerate };
}
